export default __webpack_public_path__ + "static/media/directions_2.ecff705e.svg";